import { createSelector } from 'reselect'
import { getActiveServerId } from '../activeServer/selectors'

export const getLauncherBackendVersion = state => state.backendReducer.versions.backend || -1
export const getEveClientVersions = state => state.backendReducer.versions.clients || {}
// const getEveClientVersion = (state, serverId) => {
//     const versions = getEveClientVersions(state)
//     return versions[serverId] || -1
// }
export const getActiveEveClientVersion = createSelector(
    [getActiveServerId, getEveClientVersions],
    (active, versions) => versions[active] || -1,
)



// WEBPACK FOOTER //
// ./src/features/Backend/data/versions/selectors.js